import { RotateCcw } from 'lucide-react';
import { Button } from './ui/button';

/**
 * "Try Again" on a scored phrase: record the same phrase once more. Shared by
 * Manual (under the result) and Automatic (on the score screen, Leanne,
 * 4 Nov 2026) so the two look and read the same.
 */
// `small` matches Automatic's Pause/Resume pill, which it sits under there.
// py-[5px], not py-1.5: the outline's 1px border would make it 2px taller.
export default function TryAgainButton({ onClick, testId = 'try-again-btn', small = false }) {
    return (
        <Button
            data-testid={testId}
            variant="outline"
            className={small
                ? 'h-auto gap-1.5 rounded-full border-stone-300 px-4 py-[5px] text-xs font-semibold shadow-sm [&_svg]:size-3.5'
                : 'rounded-full border-stone-300 text-xs px-5'}
            onClick={onClick}
        >
            <RotateCcw className={small ? 'h-3.5 w-3.5' : 'h-4 w-4 mr-1'} />
            Try Again
        </Button>
    );
}
